import React, { useEffect, useState } from "react";

import axiosInstance from "../../config/axios.config";
import { handleError } from "../../utils/functions";
import { toast } from "react-toastify";
import ProductFilters from "./ProductFilters";
import Loading from "./Loading";
import ProductCard from "./ProductCard";
import Pagination from "./Pagination";
import { useSearchParams } from "react-router-dom";

const ProductsSection = () => {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category");
  const subcategoryId = searchParams.get("subcategory");

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 1,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    name: "",
    rating: 0,
    maxPrice: "",
    minPrice: "",
  });

  useEffect(() => {
    const getProducts = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance({
          method: "GET",
          url: "/product/get",
          params: { ...filters, categoryId, subcategoryId },
        });
        if (!data.error) {
          setData(data.data);
          setPagination(data.pagination);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };

    getProducts();
  }, [filters, categoryId, subcategoryId]);

  return (
    <section className="productListingSection">
      <div className="container">
        <div className="row">
          <ProductFilters filters={filters} setFilters={setFilters} />
          <div className="col-md-9">
            <Loading isLoading={isLoading}>
              <div className="row g-12">
                {data.length > 0 ? (
                  <>
                    {data.map((item) => (
                      <ProductCard item={item} key={item._id} />
                    ))}
                    <Pagination
                      totalPages={pagination.totalPages}
                      currentPage={pagination.currentPage}
                      handlePageChange={(value) => setPagination((prev) => ({ ...prev, currentPage: value }))}
                    />
                  </>
                ) : (
                  <p className="">No Data Found</p>
                )}
              </div>
            </Loading>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
